/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.21.0
 * @since 1.21.0
 */

import { LinkBlock, TextBlockModal, TextBlockStatus } from '../../../../../components/common';
import { ITableCellStatusBlockProps } from './types';

const StatusBlockCell = ({ text, status, modalText }: ITableCellStatusBlockProps) => {
    return (
        <TextBlockModal disabled={!modalText} text={modalText || ''}>
            <TextBlockStatus status={status}>
                <div className="table__tooltip-text">
                    <LinkBlock disabled={!modalText}>
                        {text}
                    </LinkBlock>
                </div>
            </TextBlockStatus>
        </TextBlockModal>
    );
};

export default StatusBlockCell;
